module.exports = __webpack_public_path__ + "static/media/ThreeDPointCloudInactive.455be972.png";